define('modules/page_listing/views/empty_view',['require','exports','module','base/itemview','backbone','ldsh!../templates/empty'],function(require, exports, module) {
  "use strict";

  var ItemView = require("base/itemview"),
      Backbone = require("backbone");

  module.exports = ItemView.extend({
    template: require("ldsh!../templates/empty"),

    events: {
      "click .js-close": "resetAllFilters"
    },

    helpers: function() {
      return {
        isEmptyListing: _.bind(function() {
          return !!(this.parent.viewModel.isSearch() || this.parent.viewModel.hasFiltersApplied());
        }, this)
      };
    },

    resetAllFilters: function(e){
      Backbone.history.navigate("/pages", {trigger:true});
    },

    onRender: function() {
      this.$el.i18n();
    }
  });

});

